import { Injectable } from '@angular/core';
import { RepositoryImpl, ApiService } from '@eceos/arch';
import { Bank } from './bank';

@Injectable({ providedIn: 'root' })
export class BanksRepository extends RepositoryImpl<Bank, Bank> {
  constructor(api: ApiService) {
    super(api.root.path('financial/banks'), Bank, Bank);
  }
}
